module.exports = __webpack_public_path__ + "img/icon389.ffa51765.png";